import { useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/dag3g89tto0ceqqnhkvg";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [message, setMessage] = useState("");
  const [formError, setFormError] = useState("");

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("idle");
    setFormError("");
    const form = e.currentTarget;
    const data = new FormData(form);

    // 蜜罐：命中则给与普通成功反馈，不向服务端提交
    const honeypot = String(data.get("phone_alt") || "").trim();
    if (honeypot) {
      setStatus("ok");
      setMessage("订阅成功，重要反转与进展会第一时间推送给您。");
      return;
    }

    const payload = new URLSearchParams();
    (["name", "email", "comment"] as const).forEach((k) => {
      const v = String(data.get(k) || "").trim();
      if (v) payload.append(k, v);
    });

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let code = "";
      let serverMsg = responseText;
      try {
        const parsed = JSON.parse(responseText);
        code = parsed?.code ?? "";
        serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      } catch {
        serverMsg = responseText;
      }
      const isSpam = String(serverMsg).toLowerCase().includes("spam");
      if (res.ok && code === "OK" && !isSpam) {
        setStatus("ok");
        setMessage("订阅成功，重要反转与进展会第一时间推送给您。");
        form.reset();
      } else {
        setStatus("err");
        setFormError(isSpam ? "提交过于频繁，请稍后再试。" : serverMsg || "提交失败，请检查信息后重试。");
      }
    } catch {
      setStatus("err");
      setFormError("网络异常，请稍后再试。");
    }
  };

  return (
    <section id="subscribe" className="bg-primary-800">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-700 px-3 py-1.5 text-xs font-bold text-background-100">
              <i className="ri-notification-3-line" aria-hidden="true"></i>
              订阅追更
            </span>
            <h2 className="mt-4 text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              关注的话题出现关键进展，<br />第一时间<span className="text-secondary-300">推给你</span>
            </h2>
            <p className="mt-4 max-w-lg text-sm leading-7 text-background-200/90">
              订阅完全免费。我们只在你关注的话题出现重要反转或新进展时提醒，不做无关推送，随时可退订。
            </p>
            <ul className="mt-6 space-y-3">
              {["只推真进展，不刷屏不催更", "事件进入反转节点时优先提醒", "可随时管理关注话题与退订"].map((t) => (
                <li key={t} className="flex items-center gap-3 text-sm text-background-100">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-300/20 text-secondary-300">
                    <i className="ri-check-line text-xs" aria-hidden="true"></i>
                  </span>
                  {t}
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg bg-background-50 p-6 shadow-[0_18px_40px_-24px_rgba(0,0,0,0.35)] md:p-7">
            <form id="gt-subscribe" onSubmit={submit} data-readdy-form className="flex flex-col gap-4">
              <div className="grid gap-4 sm:grid-cols-2">
                <div>
                  <label htmlFor="name" className="mb-1.5 block text-sm font-bold text-foreground-800">怎么称呼你</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    maxLength={30}
                    placeholder="你的昵称"
                    className="w-full rounded-md border border-background-200 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-1.5 block text-sm font-bold text-foreground-800">接收邮箱</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    maxLength={80}
                    placeholder="you@example.com"
                    className="w-full rounded-md border border-background-200 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                  />
                </div>
              </div>
              <div>
                <label htmlFor="comment" className="mb-1.5 block text-sm font-bold text-foreground-800">想关注的话题（可选）</label>
                <textarea
                  id="comment"
                  name="comment"
                  maxLength={500}
                  rows={3}
                  placeholder="告诉我们你正在追更的事件，例如：某综艺下架传闻……"
                  className="w-full resize-none rounded-md border border-background-200 bg-background-50 px-3.5 py-2.5 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
                ></textarea>
              </div>

              {/* 蜜罐 */}
              <div className="gt-honeypot">
                <label htmlFor="phone_alt">联系电话</label>
                <input
                  id="phone_alt"
                  name="phone_alt"
                  type="text"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>

              <button
                type="submit"
                className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-3 text-sm font-bold text-background-50 transition hover:bg-primary-700"
              >
                订阅追更，把握每个反转
                <i className="ri-bell-line" aria-hidden="true"></i>
              </button>

              {status === "ok" && (
                <div className="flex items-center gap-2 rounded-md border border-primary-200 bg-primary-50 px-3.5 py-2.5 text-sm text-primary-700">
                  <i className="ri-checkbox-circle-line text-lg" aria-hidden="true"></i>
                  {message}
                </div>
              )}
              {status === "err" && (
                <div className="flex items-start gap-2 rounded-md border border-accent-200 bg-accent-50 px-3.5 py-2.5 text-sm text-accent-700">
                  <i className="ri-error-warning-line mt-0.5 text-lg" aria-hidden="true"></i>
                  <span>{formError}</span>
                </div>
              )}
              <p className="text-xs leading-5 text-foreground-400">
                提交即表示你同意我们仅就追更提醒与你联系，我们不会将信息用于营销或转售。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}